import { useId } from 'react';

import { type IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

export const Computer = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: IconComponentBaseProps) => {
  const maskId = useId();

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={maskId} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M1.42317 13.4872C1.28128 13.4872 1.16244 13.4393 1.06667 13.3435C0.971 13.2478 0.923167 13.1291 0.923167 12.9872C0.923167 12.8453 0.971 12.7265 1.06667 12.6308C1.16244 12.5351 1.28128 12.4872 1.42317 12.4872H14.5768C14.7187 12.4872 14.8376 12.5351 14.9333 12.6308C15.029 12.7265 15.0768 12.8453 15.0768 12.9872C15.0768 13.1291 15.029 13.2478 14.9333 13.3435C14.8376 13.4393 14.7187 13.4872 14.5768 13.4872H1.42317ZM2.87183 11.8205C2.53506 11.8205 2.25 11.7038 2.01667 11.4705C1.78333 11.2372 1.66667 10.9521 1.66667 10.6153V3.69233C1.66667 3.35556 1.78333 3.0705 2.01667 2.83717C2.25 2.60383 2.53506 2.48717 2.87183 2.48717H13.1282C13.4649 2.48717 13.75 2.60383 13.9833 2.83717C14.2167 3.0705 14.3333 3.35556 14.3333 3.69233V10.6153C14.3333 10.9521 14.2167 11.2372 13.9833 11.4705C13.75 11.7038 13.4649 11.8205 13.1282 11.8205H2.87183ZM2.87183 10.8205H13.1282C13.1795 10.8205 13.2265 10.7992 13.2692 10.7565C13.3119 10.7137 13.3333 10.6667 13.3333 10.6153V3.69233C13.3333 3.641 13.3119 3.594 13.2692 3.55133C13.2265 3.50856 13.1795 3.48717 13.1282 3.48717H2.87183C2.8205 3.48717 2.7735 3.50856 2.73083 3.55133C2.68806 3.594 2.66667 3.641 2.66667 3.69233V10.6153C2.66667 10.6667 2.68806 10.7137 2.73083 10.7565C2.7735 10.7992 2.8205 10.8205 2.87183 10.8205Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
